import type { IFeedback } from "../config";

export const feedbackMock: IFeedback = {
  heading: "Trusted by 10 000+ users worldwide",
  rating: "4,8",
  subtitle: "rating in Chrome Web Store",
  items: [
    {
      name: "James Bronner",
      rating: 5,
      text: "Saves me a lot of time and having it right next to the video is so convenient. A really great plugin.",
    },
    {
      name: "Grey Sax",
      rating: 5,
      text: "The best yet, and I've tried plenty.",
    },
    {
      name: "Vinamra Singhai",
      rating: 5,
      text: "Best way to get youtube Summary. Saves a lot of time.",
    },
    {
      name: "洪婉瑜",
      rating: 5,
      text: "Helpful to quickly grasp the idea of the video.",
    },
    {
      name: "Aqua Blast",
      rating: 5,
      text: "It's helped me save time by summarizing videos quickly. From observation, it also allows for more summaries/day than other extensions I've tried out.",
    },
    {
      name: "Alexander Hylton Parker",
      rating: 5,
      text: "This app gets to the point of every video saving valuable time, it also helps identify videos that don't have a point to make.",
    },
    {
      name: "K F",
      rating: 5,
      text: "The highly polished UI is user-friendly without disrupting YouTube's interface.",
    },
    {
      name: "Pymmusic",
      rating: 5,
      text: "For me, it is the best youtube AI summarize tool that i've found. Thank for your work! Great software!",
    },
    {
      name: "Esteban Garcia",
      rating: 5,
      text: "Perfect! This is arguably the best browser extension of 2025.",
    },
    {
      name: "Tadakuni Nagumo",
      rating: 5,
      text: "The design and the way it's summarized are very nice.",
    },
  ],
};
